"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Portal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactDom = require("react-dom");

var _usePortal = _interopRequireDefault(require("./usePortal"));

var _reactSpring = require("react-spring");

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./SideDrawer.css");

var _styles = {
  "container": "SideDrawer__container___2m3e8",
  "left": "SideDrawer__left___2vI9a",
  "header": "SideDrawer__header___3Ij8F",
  "alert-message": "SideDrawer__alert-message___1MRxG",
  "bottom": "SideDrawer__bottom___1A_Zr",
  "header-main-content": "SideDrawer__header-main-content___14mJz",
  "header-content": "SideDrawer__header-content___3Aryp",
  "main-content": "SideDrawer__main-content___3xngP",
  "padding": "SideDrawer__padding___1ckF9",
  "full-height": "SideDrawer__full-height___EZbqO",
  "footer-content": "SideDrawer__footer-content___3-gVg",
  "footer": "SideDrawer__footer___17Kdt",
  "drawer-actions-padding": "SideDrawer__drawer-actions-padding___1K2w_",
  "drawer-actions-border": "SideDrawer__drawer-actions-border___Y_6SH",
  "alert-top": "SideDrawer__alert-top___2a-3X",
  "alert-bottom": "SideDrawer__alert-bottom___BWI-B",
  "backdrop": "SideDrawer__backdrop___1Fva5",
  "show": "SideDrawer__show___208a6",
  "portal": "SideDrawer__portal___pslU_"
};

const styles = _bind.default.bind(_styles);

const Portal = (0, _mobxReact.observer)(({
  id,
  children,
  left
}) => {
  const target = (0, _usePortal.default)(id, left);
  return (0, _reactDom.createPortal)(children, target);
});
exports.Portal = Portal;
const SideDrawer = (0, _mobxReact.observer)(({
  className,
  alertMessage,
  alertType = 'info',
  alertMessagePosition = 'top',
  drawerContent,
  drawerActions,
  drawerTrigger,
  drawerHeaderContent,
  drawerFooterContent,
  mainContentPadding = true,
  mainContentFullHeight,
  drawerActionsPadding = true,
  drawerActionsBorder = true,
  leftPosition,
  portalId = 'root',
  show,
  subtitle,
  title,
  closeToggle,
  onShowToggleComplete,
  dataTestId,
  backgroundColor = _.Color.neutral.white
}) => {
  const composed_classname = (0, _bind.default)(styles('container', {
    left: leftPosition
  }), className);
  const composed_main_content_classname = (0, _bind.default)(styles('main-content', {
    padding: mainContentPadding,
    'full-height': mainContentFullHeight
  }));
  const mainContentStyles = {
    backgroundColor
  };
  const onRestFirstCall = (0, _react.useRef)(!show);
  const transitions = (0, _reactSpring.useTransition)(show, {
    from: {
      transform: `${leftPosition ? 'translateX(-100%)' : 'translateX(100%)'}`
    },
    enter: {
      transform: 'translateX(0%)'
    },
    leave: {
      transform: `${leftPosition ? 'translateX(-100%)' : 'translateX(100%)'}`
    },
    onRest: (animationResult, animationSource, animationValue) => {
      if (onRestFirstCall.current) {
        onRestFirstCall.current = false;
        return;
      }

      if (animationValue === show && onShowToggleComplete) {
        onShowToggleComplete(show);
      }
    }
  });
  (0, _react.useEffect)(() => {
    document.body.style.overflow = show ? 'hidden' : 'visible';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, [show]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Portal, {
    id: portalId,
    left: leftPosition,
    "data-testid": dataTestId
  }, _react.default.createElement("div", {
    className: styles('backdrop', {
      show
    }),
    onClick: closeToggle,
    "data-testid": dataTestId && `${dataTestId}-backdrop`
  }), transitions((props, item) => {
    return item && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactSpring.animated.div, {
      className: composed_classname,
      style: props
    }, _react.default.createElement("div", {
      className: styles('header')
    }, _react.default.createElement(_.Text, {
      variant: 'medium',
      size: 18,
      className: styles('title')
    }, title), _react.default.createElement(_.Icon, {
      name: _.IconEnum.x_mark,
      color: _.Color.neutral._60,
      size: 32,
      dataTestId: `${dataTestId}-side-drawer-close-button`,
      onClick: closeToggle
    })), alertMessage && alertMessagePosition === 'top' && _react.default.createElement(_.Alert, {
      className: styles(`alert-${alertMessagePosition}`),
      text: alertMessage,
      type: alertType,
      variant: 'in_card'
    }), _react.default.createElement("div", {
      className: styles('header-main-content')
    }, drawerHeaderContent && _react.default.createElement("div", {
      className: styles('header-content')
    }, drawerHeaderContent), _react.default.createElement("div", {
      className: composed_main_content_classname,
      style: mainContentStyles
    }, subtitle && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_.Text, {
      variant: 'medium',
      paddingBottom: 8
    }, subtitle), _react.default.createElement(_.Divider, null)), drawerContent)), alertMessage && alertMessagePosition === 'bottom' && _react.default.createElement(_.Alert, {
      className: styles(`alert-${alertMessagePosition}`),
      text: alertMessage,
      type: alertType,
      variant: 'in_card'
    }), drawerFooterContent && _react.default.createElement("div", {
      className: styles('footer-content')
    }, drawerFooterContent), drawerActions && _react.default.createElement("div", {
      className: styles('footer', {
        'drawer-actions-padding': drawerActionsPadding,
        'drawer-actions-border': drawerActionsBorder
      })
    }, drawerActions)));
  })), drawerTrigger);
});
var _default = SideDrawer;
exports.default = _default;